import { useAppSelector } from 'redux/hooks'
import { fleetApi } from 'api'
import { isOperatorSelector } from 'redux/login/selectors'
import {
  STOP_SALE_TITLE,
  STOP_SALE_ADD_BREADCRUMB,
} from 'texts/stopSellsDetails'
import { Container } from 'ui/molecules/Container'
import { initialFormValues } from '../StopSaleDetailsForm/constants'
import { StopSaleDetailsForm } from '../StopSaleDetailsForm'
import { StopSalesAdd } from 'api/fleet/types'
import { useApiRequest } from 'hooks/useApiRequest'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setNotificationMessage } from 'redux/notifications/slice'
import { STOP_SALE_SUCCESS_ADD } from 'texts/stopSells'
import { getDetailsBreadcrumbsList } from 'utils/getDetailsBreadcrumbsList'
import { formatStopSaleDate } from '../../utils'
import { useCompanyId } from 'hooks/useCompanyId'
import { resetSelectedFilters } from 'redux/filters/slice'
import { locations } from 'utils/locations'
import { FormActionButtons } from 'ui/components/FormActionButtons'
import { STOP_SALE_FORM_ID } from '../../constants'
import { URLS } from 'constants/urls'

export const StopSaleAdd = () => {
  const isOperator = useAppSelector(isOperatorSelector)

  const companyId = useCompanyId()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { apiRequest, loading } = useApiRequest(
    (values) => fleetApi.addStopSale(values),
    undefined,
    undefined,
    undefined,
    false
  )

  const breadcrumbList = getDetailsBreadcrumbsList(
    isOperator,
    String(companyId),
    'stopSells'
  )

  const handleSubmit = async (data: StopSalesAdd) => {
    const values = {
      ...data,
      from: formatStopSaleDate(data.from),
      to: formatStopSaleDate(data.to),
    }
    const response = await apiRequest(values)
    if (response) {
      dispatch(resetSelectedFilters())
      navigate(locations.stopSales(isOperator, companyId))
      dispatch(
        setNotificationMessage({
          notificationMessage: STOP_SALE_SUCCESS_ADD,
        })
      )
    }
  }

  const handleCancel = () =>
    navigate(`${URLS.FLEET}${URLS.STOP_SALES}/${companyId}`)

  return (
    <Container
      title={STOP_SALE_TITLE}
      breadcrumbList={breadcrumbList}
      currentPageLabel={STOP_SALE_ADD_BREADCRUMB}
      withNavigation={isOperator}
      rightBlock={
        <FormActionButtons
          handleBack={handleCancel}
          loading={loading}
          formId={STOP_SALE_FORM_ID}
        />
      }
    >
      <StopSaleDetailsForm
        initialValues={initialFormValues}
        handleSubmit={handleSubmit}
        isAddForm
      />
    </Container>
  )
}
